import React, { useState, useRef } from "react";
import { get as goDeep } from "lodash";
import { distance } from "../../utils/Tools";
import moment from "moment";

function FilterBar(props) {
  const { source, filterOptions, onFilter } = props;
  const [filterObj, setFilterObj] = useState({ ...filterOptions[0] });
  const [filterKey, setFilterKey] = useState(null);

  const inputField = useRef();
  const inputSelect = useRef();
  const selectBox = useRef();

  const onInputChange = e => {
    let val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFilterKey(val);
  };

  const onSelectChange = e => {
    let selected = filterOptions.filter(item => e.target.value === item.key)[0];
    setFilterObj(selected);
    if (selected.type === "select") {
      setFilterKey(selected.options[0].value);
    } else {
      setFilterKey("");
    }
  };

  const filter = e => {
    e && e.preventDefault();
    e && e.stopPropagation();
    let results = source.map(item => {
      switch (filterObj.type) {
        case "date":
          if (!Boolean(item[filterObj.key])) {
            item.visible = false;
          } else {
            if (filterObj.isSimple) {
              item.visible = item[filterObj.key] === moment(filterKey, "YYYY-MM-DD").format("DD.MM.YYYY");
            } else {
              item.visible = item[filterObj.key].split("T")[0] === filterKey;
            }
          }
          break;
        case "select":
          // item.visible = goDeep(item, filterObj.key) === filterKey;
          item.visible = goDeep(item, filterObj.key).includes(filterKey);
          break;
        case "bool":
          item.visible = goDeep(item, filterObj.key) === filterKey;
          break;
        default:
          if (filterKey === "" || filterKey === null) {
            item.visible = true;
          } else {
            if(!Boolean(goDeep(item, filterObj.key))) {
              item.visible = false;
            } else {
              if (filterObj.getDistance) {
                item.visible = distance(filterKey.toLowerCase(), goDeep(item, filterObj.key).toLowerCase()).similarity > 0.5; // Get levenshtein distance as similarity
              } else {
                item.visible = goDeep(item, filterObj.key).toLowerCase().includes(filterKey.toLowerCase());
              }
            }
          }
      }
      return item;
    });
    onFilter(results);
  };

  const resetForm = e => {
    e && e.preventDefault();
    e && e.stopPropagation();
    if (inputField.current) inputField.current.value = "";
    if (inputSelect.current) inputSelect.current.selectedIndex = 0;
    selectBox.current.selectedIndex = 0;
    setFilterKey("");
    setFilterObj({ ...filterOptions[0] });
    let resetArray = source.map(item => {
      item.visible = true;
      return item;
    });
    onFilter(resetArray);
  };

  return (
    <form className="filter-bar">
      <div className="field field-body">
        <div className="field is-narrow">
          <div className="select">
            <select ref={selectBox} onChange={onSelectChange}>
              {filterOptions.map((item, index) => (
                <option key={`flt-${index}`} value={item.key}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {filterObj.type === "select" && (
          <div className="field is-narrow">
            <div className="select">
              <select ref={inputSelect} onChange={onInputChange}>
                {filterObj.options.map((item, index) => (
                  <option key={`opt-${index}`} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        {filterObj.type === "bool" && (
          <div className="field is-narrow has-switch">
            <input ref={inputField} type="checkbox" className="switch is-rounded is-info" id="filterBar" name="filterBar" onChange={onInputChange} />
            <label htmlFor={"filterBar"} className="label">
              {filterObj.switchLabel}
            </label>
          </div>
        )}
        {filterObj.type !== "select" && filterObj.type !== "bool" && (
          <div className="field">
            <input ref={inputField} type={filterObj.type} className="input" name="filterBar" onChange={onInputChange} />
          </div>
        )}
        <div className="field is-narrow">
          <button className="button" type="button" onClick={resetForm}>
            Reset
          </button>
        </div>
        <div className="field">
          <button className="button is-success" type="submit" onClick={filter}>
            Filter
          </button>
        </div>
      </div>
    </form>
  );
}
export default FilterBar;
